<script>
import { Line } from 'vue-chartjs'

export default {
    extends: Line,
    props: [
        "data",
        "options"
    ],
    watch: {
        data: {
            handler(){
                this.render();
            },
            deep: true
        },
        options: {
            handler(){
                this.render();
            },
            deep: true
        },
        "$vuetify.breakpoint.width"(){
            this.render();
        }
    },
    methods: {
        render(){
            if(this.$data && this.$data._chart) {
                this.$data._chart.destroy();
            }

            if(this.$el.offsetParent == null){
                return;
            }

            this.$refs.canvas.width = this.$el.offsetParent.offsetWidth;
            let maxHeight = Math.floor(this.$refs.canvas.width * 3/4);
            this.$refs.canvas.height = 300;
            if(this.$refs.canvas.height > maxHeight){
                this.$refs.canvas.height = maxHeight;
            }

            this.renderChart(this.data, this.options);
        }
    },
    mounted(){
        this.render();
    }
}
</script>